import { NgModule } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { AsyncTextModule } from '../../../../async-text/async-text.module';
import { BusinessInfoComponent } from './business-info.component';
import { BusinessInfoEditComponent } from './edit/business-info-edit.component';
import { VFormModule } from '@vendasta/vform';
import { RouterModule } from '@angular/router';
import { BusinessProfileModule } from '@vendasta/businesses';
import { VaBadgeModule } from '@vendasta/uikit';
import { TranslateModule } from '@ngx-translate/core';
import { LocalTimeCardModule } from '../../../../localtime/localtime-card.module';
import { MatListModule } from '@angular/material/list';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatButtonModule } from '@angular/material/button';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import { BusinessCategoryModule } from '@galaxy/business-category';
import { FacebookIconSvg, TwitterIconSvg, LinkedInIconSvg, BusinessSearchSvg } from './icon-svg-string';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    MatInputModule,
    MatDividerModule,
    MatDialogModule,
    MatIconModule,
    AsyncTextModule,
    RouterModule,
    VFormModule,
    BusinessProfileModule,
    VaBadgeModule,
    TranslateModule,
    LocalTimeCardModule,
    MatListModule,
    MatGridListModule,
    MatButtonModule,
    GalaxyPageModule,
    BusinessCategoryModule,
    GalaxyBadgeModule,
  ],
  declarations: [BusinessInfoComponent, BusinessInfoEditComponent],
  exports: [BusinessInfoComponent, BusinessInfoEditComponent],
})
export class BusinessInfoModule {
  constructor(iconRegistry: MatIconRegistry, sanitizer: DomSanitizer) {
    iconRegistry.addSvgIconLiteral('Facebook', sanitizer.bypassSecurityTrustHtml(FacebookIconSvg));
    iconRegistry.addSvgIconLiteral('Twitter', sanitizer.bypassSecurityTrustHtml(TwitterIconSvg));
    iconRegistry.addSvgIconLiteral('LinkedIn', sanitizer.bypassSecurityTrustHtml(LinkedInIconSvg));
    iconRegistry.addSvgIconLiteral('business-search', sanitizer.bypassSecurityTrustHtml(BusinessSearchSvg));
  }
}
